export default "__VITE_ASSET__e01fe43e__"